export default {
  header: (numberOfNewLanguages: number): string => `Introducing ${numberOfNewLanguages} more language${numberOfNewLanguages > 1 ? 's' : ''}`,
  nowAvailable: (newLanguage: string[]): string => `PaymentsOS is now available in
${newLanguage.join(', ')}.`,
  youCanChoose: 'You can choose your language from the dropdown menu',
  or: 'or',
  changeLater: 'change it later in your user profile',
  dontShowAgain: 'Got it! Don\'t show this message again'
}
